import { Component, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { CrudCreateComponent } from '../../../shared/components/crud/create/create.component';
import { FormField } from '../../../constants/form.constants';
import { PLANES_FIELDS_FORM } from '../../../constants/planes.constants';
import { ModalidadService } from '../../../core/modalidad.service';
import { NivelService } from '../../../core/nivel.service';
import { PlanesService } from '../../../core/planes.service';

@Component({
  selector: 'app-planes-create',
  templateUrl: './planes-create.component.html',
  styleUrls: ['./planes-create.component.scss'],
  imports: [CrudCreateComponent],
})
export class PlanesCreateComponent {
  fields: { [name: string]: FormField } = PLANES_FIELDS_FORM;
  @Input() title: string = '';
  planesService = new PlanesService;
  modalidadService = new ModalidadService;
  nivelService = new NivelService;
  ngOnInit() {
    this.modalidadService.getAllForSelect().subscribe((data) => {
      this.fields['modalidad_id'].options = data;
    });
    this.nivelService.getAllForSelect().subscribe((data) => {
      this.fields['nivel_id'].options = data;
    });
  }
}
